/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cleanSaveRequestListener, createSaveRequestListener } from 'InpageEditorUI/lib/SaveShortcutChecker';
import ModuleEditorStore from 'InpageEditorUI/lib/ModuleEditorStore';
import { InpageModes } from 'ContentEditorUI/lib/app/constants';
import { updateSelectedItem, clearSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import { addModulesToPostBody } from 'ContentEditorUI/redux/actions/moduleActions';
import { getAllModuleSchemas, getAllModuleSchemasByModuleId, makeGetSchemaForModule, getBuiltInTypesByModuleId } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { getWidgetsInRichText } from 'ContentEditorUI/redux/selectors/moduleSelectorHelpers';
import { closeRichTextEditorFirefox, openRichTextEditorFirefox, updatePostBodyFromInline, updateTitleFromInline, updateInpageMode, trackedFailedInpageAssets } from 'ContentEditorUI/redux/actions/inpageActions';
import { undoModuleReducerChange, redoModuleReducerChange } from 'ContentEditorUI/redux/actions/undoRedoActions';
import { pick, isEqual } from 'underscore';
import { getPortalId, getHasGlobalContentEditorAccess, getHasTinyMCEParsedFonts, getHasTinyMCEParsedFontsEnabled, getHasPersonalizationAccess, getHasPreventTinymceTransformsOnUndo, getIsUngatedForModuleFieldEditing, getIsUngatedToRepositionPostBodyModules, getHasAudioNarrationAccess, getHasImageGenerationAccess, getIsUngatedForSCPWidgetEditor } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getHasAIGeneratedContentFeature, getCanUseCopilotCollaborationMinusContentAssistanceCheck } from 'ContentEditorUI/redux/selectors/featureSelectors';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getPrevSelectedItemId, getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getSmartViewCriterionId } from 'ContentEditorUI/redux/selectors/smartViewSelectors';
import { getIsSmartContentPreview } from 'ContentEditorUI/redux/selectors/iframesSelectors';
import { getIsDistractionFreeOpen } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import { getModuleMatchingSmartObjectIndex, getModulesByNameFromPostBody, isFakeBodyModuleName } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { createAsyncWidgetEditor } from 'InpageEditorUI/components/AsyncComponents';
import { getIsAdvancedPageTemplateWithAccess, getIsStarterPageTemplate } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { openConfirmEditGlobal, openAudioNarrationPanel } from 'ContentEditorUI/redux/actions/appActions';
import { getIsBlogPost, getIsLandingPage, getIsSitePage, getIsLandingOrSitePage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getShouldForceTinymceReadonlyIssue } from 'ContentEditorUI/redux/selectors/testFlagSelectors';
import { isApplyChangesModalOpen } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { getThemesCustomFontsList } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { HIGHLIGHTED_CLASS } from 'InpageEditorUI/lib/dom';
import { getWidgetElement, isInlineScpEditable } from 'InpageEditorUI/lib/inpage/utils';
import { getIsDataAuthoringModeActive, getCurrentHubDbFields } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { getCrmObjectSchemaAsCmv2Schema, getCrmObjectValuesAsFieldValues } from 'ContentEditorUI/redux/selectors/crmObjectEditingSelectors';
import ModuleDomNodeStore from 'InpageEditorUI/lib/ModuleDomNodeStore';
import ModuleInlineEditingContainer from 'InpageEditorUI/containers/ModuleInlineEditingContainer';
import CrmInlineEditingWrapper from './CrmInlineEditingWrapper';
import { widgetUpdatePending, mergeModuleBody, updateModuleMetaData } from 'InpageEditorUI/eventsAsActions/widgetEditorTransitionEventsAsActions';
import { getHasAccessToBrandVoice, getIsContentAssistanceEnabled, getBlogBrandVoice, getPageBrandVoice } from 'ContentEditorUI/redux/selectors/contentAssistantSelectors';
import { updateInstanceValue, updateInstanceMetaData } from 'structured-content-lib/redux/actions/instanceEditActions';
import { selectCurrentInstance, selectModuleValues } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { setDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import { BlogPlgOnboardingUITourStepPostBody } from 'InpageEditorUI/components/onboarding/BlogOnboardingUITourStepPostBody';
import { TourStepWrapper } from 'InpageEditorUI/components/onboarding/TourStepWrapper';
import { hasOwn, getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
import { updateCrmObjectProperty } from 'ContentEditorUI/redux/actions/crmObjectEditingActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_OBJECT = {};
const mapStateToProps = () => {
  const getSchemaForModule = makeGetSchemaForModule();
  return (state, {
    widget
  }) => {
    const modulesByNameFromPostBody = getModulesByNameFromPostBody(state);
    const isPostBodyModule = hasOwn(modulesByNameFromPostBody, widget.name);
    const isDataAuthoringModeActive = getIsDataAuthoringModeActive(state);
    const currentInstance = selectCurrentInstance(state);
    return {
      portalId: getPortalId(state),
      moduleSchema: getSchemaForModule(state, widget),
      contentModelId: getContentModelId(state),
      allModuleSchemasByCid: getAllModuleSchemas(state),
      allModuleSchemasByModuleId: getAllModuleSchemasByModuleId(state),
      hasPersonalizationAccess: getHasPersonalizationAccess(state),
      isStarterPageTemplate: getIsStarterPageTemplate(state),
      isAdvancedPageTemplateWithAccess: getIsAdvancedPageTemplateWithAccess(state),
      isInDefaultBreakpointMode: getIsInDefaultBreakpointMode(state),
      shouldForceTinymceReadonlyIssue: getShouldForceTinymceReadonlyIssue(state),
      hasGlobalContentEditorAccess: getHasGlobalContentEditorAccess(state),
      hasPreventTinymceTransformsOnUndo: getHasPreventTinymceTransformsOnUndo(state),
      prevSelectedItemId: getPrevSelectedItemId(state),
      selectedItemId: getSelectedItemId(state),
      selectedSmartRuleId: getSmartViewCriterionId(state),
      isSmartContentPreview: getIsSmartContentPreview(state),
      hasTinyMCEParsedFonts: getHasTinyMCEParsedFonts(state),
      customFontsList: getThemesCustomFontsList(state),
      hasTinyMCEParsedFontsEnabled: getHasTinyMCEParsedFontsEnabled(state),
      hasAIGeneratedContentFeature: getHasAIGeneratedContentFeature(state),
      canUseCopilotCollaboration: getCanUseCopilotCollaborationMinusContentAssistanceCheck(state),
      hasNewCtasInRichText: true,
      moduleMatchingSmartObjectIndex: getModuleMatchingSmartObjectIndex(state, widget.id),
      applyChangesModalOpen: isApplyChangesModalOpen(state),
      postBodyModulesByName: modulesByNameFromPostBody,
      isPostBodyModule,
      isDataAuthoringModeActive,
      isUngatedForCaseStudyWidgetEditor: getIsUngatedForSCPWidgetEditor(state),
      currentHubDbFields: getCurrentHubDbFields(state),
      crmObjectObjectAsCmv2Schema: getCrmObjectSchemaAsCmv2Schema(state),
      crmObjectFieldValues: getCrmObjectValuesAsFieldValues(state),
      rowAsModuleBody: !!currentInstance && isDataAuthoringModeActive ? selectModuleValues(state) : EMPTY_OBJECT,
      hasInlineFieldEditing: getIsUngatedForModuleFieldEditing(state),
      modulesInRichText: getWidgetsInRichText(state),
      // Used to instantiate specific page or blog specific widget editors later
      // and should _not_ be used for other conditional logic
      isBlogPost: getIsBlogPost(state),
      isLandingPage: getIsLandingPage(state),
      isSitePage: getIsSitePage(state),
      isLandingOrSitePage: getIsLandingOrSitePage(state),
      isDistractionFreeOpen: getIsDistractionFreeOpen(state),
      builtInTypesByModuleId: getBuiltInTypesByModuleId(state),
      hasImageGenerationAccess: getHasImageGenerationAccess(state),
      isContentAssistanceEnabled: getIsContentAssistanceEnabled(state),
      blogBrandVoice: getBlogBrandVoice(state),
      pageBrandVoice: getPageBrandVoice(state),
      isUngatedToRepositionPostBodyModules: getIsUngatedToRepositionPostBodyModules(state),
      hasAccessToBrandVoice: getHasAccessToBrandVoice(state),
      hasAccessToAudioNarration: getHasAudioNarrationAccess(state)
    };
  };
};
const mapDispatchToProps = {
  addModulesToPostBody,
  openConfirmEditGlobal,
  openAudioNarrationPanel,
  closeRichTextEditorFirefox,
  openRichTextEditorFirefox,
  redoModuleReducerChange,
  clearSelectedItem,
  updateSelectedItem,
  undoModuleReducerChange,
  updatePostBodyFromInline,
  updateTitleFromInline,
  updateInpageMode,
  trackedFailedInpageAssets,
  updateInstanceValue,
  updateInstanceMetaData,
  updateCrmObjectProperty
};
class WidgetEditorWrapper extends Component {
  constructor(props) {
    super(props);
    this.triggerSave = () => {
      const {
        selectedItemId,
        widget
      } = this.props;
      if (widget.name === selectedItemId) {
        this.executeWhenWidgetEditorLoads(widgetEditor => {
          widgetEditor.sendUpdateMessage();
        });
      }
    };
    this.getCrmObjectFieldValues = () => {
      const {
        crmObjectFieldValues
      } = this.props;
      return crmObjectFieldValues;
    };
    this.getCrmObjectSchemaAsCmv2Schema = () => {
      const {
        crmObjectObjectAsCmv2Schema
      } = this.props;
      return crmObjectObjectAsCmv2Schema;
    };
    this.getModuleSchemaByCid = cid => {
      const {
        allModuleSchemasByCid
      } = this.props;
      return allModuleSchemasByCid[cid];
    };
    this.getModuleSchemaByModuleId = moduleId => {
      const {
        allModuleSchemasByModuleId
      } = this.props;
      return allModuleSchemasByModuleId[moduleId];
    };
    this.getModuleSchemaById = id => {
      const {
        allModuleSchemasByModuleId,
        allModuleSchemasByCid
      } = this.props;
      if (allModuleSchemasByCid[id]) {
        return allModuleSchemasByCid[id];
      } else if (allModuleSchemasByModuleId[id]) {
        return allModuleSchemasByModuleId[id];
      } else {
        return null;
      }
    };
    this.getInpageMode = () => {
      return this.props.currentInpageMode;
    };
    this.getIsInDefaultBreakpointMode = () => {
      return this.props.isInDefaultBreakpointMode;
    };
    this.getShouldForceTinymceReadonlyIssue = () => {
      return this.props.shouldForceTinymceReadonlyIssue;
    };
    this.getIsFocusedWidget = () => {
      const {
        selectedItemId,
        widget
      } = this.props;
      return widget.name === selectedItemId;
    };
    this.getIsAnythingSelected = () => {
      const {
        isAnythingSelected
      } = this.props;
      return isAnythingSelected;
    };
    this.getHasImageGenerationAccess = () => {
      const {
        hasImageGenerationAccess
      } = this.props;
      return hasImageGenerationAccess;
    };
    this.getIsUngatedForSCPWidgetEditor = () => {
      const {
        isUngatedForCaseStudyWidgetEditor
      } = this.props;
      return isUngatedForCaseStudyWidgetEditor;
    };
    this.getHasPreventTinymceTransformsOnUndo = () => {
      const {
        hasPreventTinymceTransformsOnUndo
      } = this.props;
      return hasPreventTinymceTransformsOnUndo;
    };
    this.getCustomFontsList = () => {
      const {
        customFontsList
      } = this.props;
      return customFontsList;
    };
    this.getHasGlobalContentEditorAccess = () => {
      const {
        hasGlobalContentEditorAccess
      } = this.props;
      return hasGlobalContentEditorAccess;
    };
    this.getIsAdvancedPageTemplateWithAccess = () => {
      const {
        isAdvancedPageTemplateWithAccess
      } = this.props;
      return isAdvancedPageTemplateWithAccess;
    };
    this.getSelectedItemId = () => {
      return this.props.selectedItemId;
    };
    this.getPrevSelectedItemId = () => {
      return this.props.prevSelectedItemId;
    };
    this.getIsStarterPageTemplate = () => {
      const {
        isStarterPageTemplate
      } = this.props;
      return isStarterPageTemplate;
    };
    this.getHasPersonalizationAccess = () => {
      const {
        hasPersonalizationAccess
      } = this.props;
      return hasPersonalizationAccess;
    };
    this.getIsDataAuthoringModeActive = () => {
      const {
        isDataAuthoringModeActive
      } = this.props;
      return isDataAuthoringModeActive;
    };
    this.getSidebarIsExpanded = () => {
      return this.props.sidebarIsExpanded;
    };
    this.getModulesByNameFromPostBody = () => {
      return this.props.postBodyModulesByName;
    };
    this.getModuleInRichTextByName = name => {
      return this.props.postBodyModulesByName[name];
    };
    this.getScpModuleInRichTextByName = name => {
      return getImmutableOrPlain(this.props.modulesInRichText, name);
    };
    this.getBuiltInTypesByModuleId = () => {
      return this.props.builtInTypesByModuleId;
    };
    this.getHasAIGeneratedContentFeature = () => {
      return this.props.hasAIGeneratedContentFeature;
    };
    this.getIsContentAssistanceEnabled = () => {
      return this.props.isContentAssistanceEnabled;
    };
    this.getCanUseCopilotCollaborationMinusContentAssistanceCheck = () => {
      return this.props.canUseCopilotCollaboration;
    };
    this.getBlogBrandVoice = () => {
      return this.props.blogBrandVoice;
    };
    this.getPageBrandVoice = () => {
      return this.props.pageBrandVoice;
    };
    this.getHasAccessToBrandVoice = () => {
      return this.props.hasAccessToBrandVoice;
    };
    this.getHasAccessToAudioNarration = () => {
      return this.props.hasAccessToAudioNarration;
    };
    this.getIsUngatedToRepositionPostBodyModules = () => {
      return this.props.isUngatedToRepositionPostBodyModules;
    };
    this.getIsDistractionFreeOpen = () => {
      return this.props.isDistractionFreeOpen;
    };
    this.getIsLandingPage = () => {
      return this.props.isLandingPage;
    };
    this.getIsSitePage = () => {
      return this.props.isSitePage;
    };
    this.getHasDataTokens = () => {
      const {
        widget
      } = this.props;
      return Boolean(widget && widget.body && widget.body.data_tokens);
    };
    this.handleUpdateInpageMode = mode => {
      this.props.updateInpageMode(mode);
    };
    this.handleUndoModuleReducerChange = () => {
      this.props.undoModuleReducerChange();
    };
    this.handleRedoModuleReducerChange = () => {
      this.props.redoModuleReducerChange();
    };
    this.handleClearSelectedItem = (widgetName, options) => {
      this.props.clearSelectedItem(Object.assign({
        onlyIfSelected: widgetName
      }, options));
    };
    this.handleUpdateSelectedItem = (widget, options = {}) => {
      this.props.updateSelectedItem(widget.name, Object.assign({
        containerId: widget.layout_section_id
      }, options));
    };
    this.handleOpenConfirmEditGlobal = widget => {
      this.props.openConfirmEditGlobal(widget.name);
    };
    this.handleUpdatePostBodyFromInline = (value, metaData, undoData) => {
      return this.props.updatePostBodyFromInline(value, metaData, undoData);
    };
    this.handleUpdateTitleFromInline = (value, metaData, undoData) => {
      return this.props.updateTitleFromInline(value, metaData, undoData);
    };
    this.handleOpenRichTextEditorFirefox = () => {
      this.props.openRichTextEditorFirefox();
    };
    this.handleCloseRichTextEditorFirefox = () => {
      this.props.closeRichTextEditorFirefox();
    };
    this.addModulesToPostBody = (modules, html, undoData, metaData) => {
      return this.props.addModulesToPostBody(modules, html, undoData, metaData);
    };
    this.handleFocusInlineRichTextWithPlaceholder = fieldName => {
      const {
        widget
      } = this.props;
      const options = {
        containerId: widget.layout_section_id
      };
      if (this.getIsDataAuthoringModeActive() && this.getIsUngatedForSCPWidgetEditor() && this.getHasDataTokens()) {
        const dataTokenPaths = Object.values(widget.body.data_tokens);
        if (dataTokenPaths.length === 1 && dataTokenPaths[0].includes(fieldName)) {
          options.doNotShowSidebarForm = true;
          options.clearOutPanels = true;
        }
      }
      this.props.updateSelectedItem(widget.name, options);
    };
    this.registerInlineFieldRef = (fieldName, fieldType, ref = {}) => {
      this.inlineFieldRefs[fieldName] = Object.assign({
        type: fieldType
      }, ref);
    };
    this.handleInlineCrmFieldChange = (crmObjectKey, path, value) => {
      this.props.updateCrmObjectProperty({
        path: [crmObjectKey, ...path],
        value
      });
    };
    createSaveRequestListener(this.triggerSave);
    const moduleElement = document.getElementById(`hs_cos_wrapper_${props.widget.name}`);
    ModuleDomNodeStore.set(props.widget.name, moduleElement);
    this.handleInlineHubDbInstancePropertyChange = this.handleInlineHubDbInstancePropertyChange.bind(this);
    this.handleInlineModuleChange = this.handleInlineModuleChange.bind(this);
    this.handleFocusInlineRichTextWithPlaceholder = this.handleFocusInlineRichTextWithPlaceholder.bind(this);
    this.updateModuleMetaData = this.updateModuleMetaData.bind(this);
    this.updateStructuredContentMetaData = this.updateStructuredContentMetaData.bind(this);
    this.inlineFieldRefs = {};
  }
  componentDidMount() {
    const {
      bus,
      selectedItemId,
      widget,
      isDistractionFreeOpen
    } = this.props;
    if (this.props.moduleSchema) {
      this.createAsyncWidgetEditor();
    }
    this.executeWhenWidgetEditorLoads(() => {
      const {
        $widget
      } = getWidgetElement(widget);
      bus.postMessage({
        action: `InpageModuleContext:updateModuleRef`,
        payload: {
          widget,
          isInlineScpEditable: isInlineScpEditable(widget, $widget)
        }
      });
    });
    if (selectedItemId) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        if (widget.name === selectedItemId) widgetEditor.focusWidget();
      });
    }
    if (isDistractionFreeOpen) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        if (widgetEditor.handleToggleDistractionFree) {
          widgetEditor.handleToggleDistractionFree(isDistractionFreeOpen);
        }
      });
    }
  }
  componentDidUpdate(prevProps) {
    const {
      selectedItemId,
      highlightedWidgetId,
      widget,
      sidebarIsExpanded,
      currentInpageMode,
      moduleSchema,
      applyChangesModalOpen,
      customFontsList,
      isDistractionFreeOpen,
      postBodyModulesByName,
      modulesInRichText,
      isContentAssistanceEnabled,
      blogBrandVoice,
      pageBrandVoice,
      isDataAuthoringModeActive
    } = this.props;
    if (prevProps.moduleSchema !== moduleSchema) {
      this.createAsyncWidgetEditor();
    }
    if (prevProps.highlightedWidgetId !== highlightedWidgetId) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        if (highlightedWidgetId === widget.name) {
          this.addHighlightClass(widgetEditor.$widget);
        } else if (prevProps.highlightedWidgetId === widget.name) {
          this.removeHighlightClass(widgetEditor.$widget);
        }
      });
    }
    if (sidebarIsExpanded !== prevProps.sidebarIsExpanded) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        widgetEditor.handleSidebarChange({
          sidebarIsExpanded
        });
      });
    }
    if (prevProps.currentInpageMode !== currentInpageMode) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        if (widgetEditor.handleModeChange) {
          widgetEditor.handleModeChange(currentInpageMode, prevProps.currentInpageMode);
        }
        if (widget.name === selectedItemId && currentInpageMode !== InpageModes.EDIT) {
          widgetEditor.blurWidget();
        }
      });
    }
    if (prevProps.selectedItemId !== selectedItemId) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        if (widget.name === prevProps.selectedItemId) {
          widgetEditor.blurWidget();
        } else if (widget.name === selectedItemId && widget.overrideable) {
          widgetEditor.focusWidget();
          // Manually focus on the inline field if there is only one richtext/text field
          const inlineFieldRefKeys = Object.keys(this.inlineFieldRefs);
          if (isDataAuthoringModeActive && inlineFieldRefKeys.length === 1) {
            const fieldName = inlineFieldRefKeys[0];
            const fieldRef = this.inlineFieldRefs[fieldName];
            if (fieldRef.type === 'richtext' || fieldRef.type === 'text') {
              // Let any scroll animations complete before focusing the field
              setTimeout(() => {
                fieldRef.focus();
              });
            }
          }
        }
        // Notify the parent rich text module that the selected module has changed.
        // Currently only the blog post body module and structured-content tied
        // to a single data richtext data token is supported.
        if (isFakeBodyModuleName(widgetEditor.widget.name) && typeof widgetEditor.onModuleSelected === 'function') {
          const selectedModule = ModuleEditorStore.get(selectedItemId);
          if (selectedModule && (hasOwn(postBodyModulesByName, selectedModule.widget.name) || modulesInRichText[selectedModule.widget.name])) {
            widgetEditor.onModuleSelected(selectedModule.widget.name);
          }
        }
      });
    }
    if (prevProps.isContentAssistanceEnabled !== isContentAssistanceEnabled || !isEqual(prevProps.blogBrandVoice, blogBrandVoice) || !isEqual(prevProps.pageBrandVoice, pageBrandVoice)) {
      // Force RichText to recompute TinyMCE config when updating isContentAssistanceEnabled
      // Will re-init all tinymce instances, but shouldn't happen often
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        widgetEditor.render();
      });
    }
    if (prevProps.applyChangesModalOpen && !applyChangesModalOpen && prevProps.selectedItemId === selectedItemId && selectedItemId === widget.name) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        widgetEditor.focusWidget();
      });
    }
    if (prevProps.customFontsList !== customFontsList) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        widgetEditor.render();
      });
    }
    if (prevProps.isDistractionFreeOpen !== isDistractionFreeOpen) {
      this.executeWhenWidgetEditorLoads(widgetEditor => {
        if (widgetEditor.handleToggleDistractionFree) {
          widgetEditor.handleToggleDistractionFree(isDistractionFreeOpen);
        }
      });
    }
  }
  componentWillUnmount() {
    this.executeWhenWidgetEditorLoads(widgetEditor => {
      widgetEditor.recycle();
    });
    cleanSaveRequestListener();
  }
  createAsyncWidgetEditor() {
    const {
      widget,
      gates,
      bus,
      scopes,
      portalId,
      userId,
      selectedItemId,
      highlightedWidgetId,
      renderLanguage,
      hasUndoRedoAccess,
      hasTinyMCEParsedFonts,
      hasTinyMCEParsedFontsEnabled,
      hasNewCtasInRichText,
      tellParentToHideModuleMenu,
      shouldShowFakeWidgetEditors,
      updateNodePositions,
      layoutSectionHoverPositionsClearedAndFrozen,
      layoutSectionHoverPositionsThawed,
      tinyMceGlobals,
      pickerComponentsWithState,
      moduleSchema,
      contentModelId,
      selectedSmartRuleId,
      moduleMatchingSmartObjectIndex,
      isSmartContentPreview,
      isBlogPost,
      isLandingOrSitePage
    } = this.props;
    const {
      $widget,
      wrapperType
    } = getWidgetElement(widget);
    if (!$widget || $widget.length === 0) {
      return;
    }
    this.asyncWidgetEditor = createAsyncWidgetEditor().then(({
      default: createWidgetEditor
    }) => {
      const widgetEditor = createWidgetEditor({
        widget,
        $widget,
        wrapperType,
        gates,
        bus,
        scopes,
        portalId,
        userId,
        tinyMceGlobals,
        pickerComponentsWithState,
        selectedItemId,
        // Specific state that some widget editors need
        renderLanguage,
        hasUndoRedoAccess,
        moduleSchema,
        contentModelId,
        customFontsList: this.getCustomFontsList(),
        hasTinyMCEParsedFonts,
        hasTinyMCEParsedFontsEnabled,
        hasNewCtasInRichText,
        selectedSmartRuleId,
        moduleMatchingSmartObjectIndex,
        isSmartContentPreview,
        isBlogPost,
        isLandingOrSitePage,
        // Various functions the widget editors used to do by calling on a EditController reference
        editControllerFuncs: {
          tellParentToHideModuleMenu,
          shouldShowFakeWidgetEditors,
          updateNodePositions,
          layoutSectionHoverPositionsClearedAndFrozen,
          layoutSectionHoverPositionsThawed
        },
        // Hacks to allow old WidgetEditor code easily access state that is now in React-land
        stateAccessors: {
          getModuleSchemaByCid: this.getModuleSchemaByCid,
          getModuleSchemaByModuleId: this.getModuleSchemaByModuleId,
          getInpageMode: this.getInpageMode,
          getIsFocusedWidget: this.getIsFocusedWidget,
          getIsAnythingSelected: this.getIsAnythingSelected,
          getSidebarIsExpanded: this.getSidebarIsExpanded,
          getHasGlobalContentEditorAccess: this.getHasGlobalContentEditorAccess,
          getHasPersonalizationAccess: this.getHasPersonalizationAccess,
          getIsUngatedForSCPWidgetEditor: this.getIsUngatedForSCPWidgetEditor,
          getIsStarterPageTemplate: this.getIsStarterPageTemplate,
          getIsAdvancedPageTemplateWithAccess: this.getIsAdvancedPageTemplateWithAccess,
          getIsInDefaultBreakpointMode: this.getIsInDefaultBreakpointMode,
          getIsModuleStyleable: this.getIsModuleStyleable,
          getShouldForceTinymceReadonlyIssue: this.getShouldForceTinymceReadonlyIssue,
          getSelectedItemId: this.getSelectedItemId,
          getPrevSelectedItemId: this.getPrevSelectedItemId,
          getModulesByNameFromPostBody: this.getModulesByNameFromPostBody,
          getModuleInRichTextByName: this.getModuleInRichTextByName,
          getBuiltInTypesByModuleId: this.getBuiltInTypesByModuleId,
          hasPreventTinymceTransformsOnUndo: this.getHasPreventTinymceTransformsOnUndo,
          getHasAIGeneratedContentFeature: this.getHasAIGeneratedContentFeature,
          getCanUseCopilotCollaborationMinusContentAssistanceCheck: this.getCanUseCopilotCollaborationMinusContentAssistanceCheck,
          getHasImageGenerationAccess: this.getHasImageGenerationAccess,
          getIsDataAuthoringModeActive: this.getIsDataAuthoringModeActive,
          getIsContentAssistanceEnabled: this.getIsContentAssistanceEnabled,
          getBlogBrandVoice: this.getBlogBrandVoice,
          getPageBrandVoice: this.getPageBrandVoice,
          getIsUngatedToRepositionPostBodyModules: this.getIsUngatedToRepositionPostBodyModules,
          getHasAccessToBrandVoice: this.getHasAccessToBrandVoice,
          getHasAccessToAudioNarration: this.getHasAccessToAudioNarration,
          getIsLandingPage: this.getIsLandingPage,
          getIsSitePage: this.getIsSitePage,
          getIsDistractionFreeOpen: this.getIsDistractionFreeOpen,
          getHasDataTokens: this.getHasDataTokens,
          getCrmObjectFieldValues: this.getCrmObjectFieldValues,
          getCrmObjectSchemaAsCmv2Schema: this.getCrmObjectSchemaAsCmv2Schema
        },
        // Hacks to allow old WidgetEditor code easily update state that is now in React-land
        stateModifiers: {
          addModulesToPostBody: this.addModulesToPostBody,
          onRedoModuleReducerChange: this.handleRedoModuleReducerChange,
          onClearSelectedItem: this.handleClearSelectedItem,
          onUpdateSelectedItem: this.handleUpdateSelectedItem,
          openConfirmEditGlobal: this.handleOpenConfirmEditGlobal,
          onUndoModuleReducerChange: this.handleUndoModuleReducerChange,
          onUpdateInpageMode: this.handleUpdateInpageMode,
          onUpdatePostBodyFromInline: this.handleUpdatePostBodyFromInline,
          onUpdateTitleFromInline: this.handleUpdateTitleFromInline,
          onOpenRichTextEditorFirefox: this.handleOpenRichTextEditorFirefox,
          onCloseRichTextEditorFirefox: this.handleCloseRichTextEditorFirefox,
          openAudioNarrationPanel: this.props.openAudioNarrationPanel
        }
      });
      if (widgetEditor) {
        ModuleEditorStore.set(widget.name, widgetEditor);
        widgetEditor.render();
        this.addSeleniumReadyClass(widgetEditor.$widget);
        if (highlightedWidgetId === widget.name) {
          this.addHighlightClass(widgetEditor.$widget);
        }
      }
      return widgetEditor;
    }).catch(err => {
      console.error('Unable to load the AsyncWidgetEditor', err);
      this.props.trackedFailedInpageAssets([`Couldn't create widget editor for ${widget.name} (${widget.type}): ${err.message}`]);
    });
  }
  executeWhenWidgetEditorLoads(fn) {
    if (this.asyncWidgetEditor) {
      this.asyncWidgetEditor.then(widgetEditor => widgetEditor && fn(widgetEditor));
    }
  }
  addSeleniumReadyClass(element) {
    element.attr('data-test', 'selenium-widget-editor-ready');
  }
  addHighlightClass(element) {
    element.addClass(HIGHLIGHTED_CLASS);
  }
  removeHighlightClass(element) {
    element.removeClass(HIGHLIGHTED_CLASS);
  }
  handleInlineHubDbInstancePropertyChange(keyPath, value, undoData = {}, metaData = {}) {
    const {
      bus
    } = this.props;
    bus.dispatchActionToEventBus(widgetUpdatePending());
    if (keyPath.length > 1) {
      throw new Error('Expected only 1 key in patch');
    }
    const instanceProperty = keyPath[0];
    this.props.updateInstanceValue(instanceProperty, value, {
      undoData,
      metaData
    });
    this.executeWhenWidgetEditorLoads(widgetEditor => {
      widgetEditor.onInlineChange();
    });
  }
  handleInlineModuleChange(keyPath, value, undoData = {}, metaData = {}) {
    // TODO How do we handle metaData and undoData?
    const {
      widget,
      isSmartContentPreview,
      selectedSmartRuleId,
      moduleMatchingSmartObjectIndex,
      bus,
      moduleSchema
    } = this.props;
    bus.dispatchActionToEventBus(widgetUpdatePending());
    let newModule = setDeepValue(widget.body, keyPath, value);
    const topLevelFieldNames = moduleSchema && moduleSchema.fields ? moduleSchema.fields.map(_field => _field.name) : [];
    newModule = pick(newModule, topLevelFieldNames);
    // TODO: Debounce at the field level?
    bus.dispatchActionToEventBus(mergeModuleBody(widget.name, newModule, null, {
      metaData,
      undoData,
      isSmartContentPreview,
      selectedSmartRuleId,
      matchingSmartObjectIndex: moduleMatchingSmartObjectIndex,
      updateEditVersion: true
    }));
    this.executeWhenWidgetEditorLoads(widgetEditor => {
      widgetEditor.onInlineChange();
    });
  }
  updateModuleMetaData(metaData) {
    const {
      widget,
      bus
    } = this.props;
    bus.dispatchActionToEventBus(updateModuleMetaData(widget.name, metaData));
  }
  updateStructuredContentMetaData(metaData, columnName) {
    // This differs from the `updateModuleMetaData` because in this case,
    // we need to update `structuredContent`'s meta data instead of a module's
    this.props.updateInstanceMetaData(columnName, metaData);
  }
  renderCrmInlineEditing() {
    const {
      widget,
      crmObjectObjectAsCmv2Schema,
      crmObjectFieldValues
    } = this.props;
    // Skip rendering if schema isn't available
    if (!crmObjectObjectAsCmv2Schema || !crmObjectFieldValues || !Object.keys(crmObjectObjectAsCmv2Schema).length || !Object.keys(crmObjectFieldValues).length) {
      return null;
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: Object.keys(crmObjectObjectAsCmv2Schema).map(crmObjectKey => {
        const fields = crmObjectObjectAsCmv2Schema[crmObjectKey];
        const values = (crmObjectFieldValues === null || crmObjectFieldValues === void 0 ? void 0 : crmObjectFieldValues[crmObjectKey]) || {};
        return /*#__PURE__*/_jsx(CrmInlineEditingWrapper, {
          crmObjectKey: crmObjectKey,
          moduleName: widget.name,
          fields: fields,
          values: values,
          handleInlineCrmFieldChange: this.handleInlineCrmFieldChange,
          handleFocusInlineRichTextWithPlaceholder: this.handleFocusInlineRichTextWithPlaceholder,
          getModuleSchemaById: this.getModuleSchemaById,
          getScpModuleInRichTextByName: this.getScpModuleInRichTextByName,
          getSelectedItemId: this.getSelectedItemId,
          updateStructuredContentMetaData: this.updateStructuredContentMetaData,
          registerInlineFieldRef: this.registerInlineFieldRef
        }, crmObjectKey);
      })
    });
  }
  render() {
    const {
      isDataAuthoringModeActive,
      widget,
      currentHubDbFields,
      rowAsModuleBody,
      hasInlineFieldEditing,
      moduleSchema,
      isPostBodyModule,
      isSmartContentPreview,
      selectedItemId,
      selectedSmartRuleId
    } = this.props;
    if (widget.name === 'post_body') {
      return /*#__PURE__*/_jsx(BlogPlgOnboardingUITourStepPostBody, {});
    }
    if (isDataAuthoringModeActive) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [this.renderCrmInlineEditing(), /*#__PURE__*/_jsx(TourStepWrapper, {
          moduleSchema: moduleSchema,
          widget: widget,
          children: /*#__PURE__*/_jsx(ModuleInlineEditingContainer, {
            moduleName: widget.name,
            onChange: this.handleInlineHubDbInstancePropertyChange,
            fields: currentHubDbFields,
            fieldValues: rowAsModuleBody,
            inlineType: "hubdb",
            inlineDataSource: "dynamic_page_hubdb_row",
            handleFocusInlineRichTextWithPlaceholder: this.handleFocusInlineRichTextWithPlaceholder,
            getModuleSchemaById: this.getModuleSchemaById,
            getScpModuleInRichTextByName: this.getScpModuleInRichTextByName,
            getSelectedItemId: this.getSelectedItemId,
            updateMetaData: this.updateStructuredContentMetaData
            // Only turning this on for data authoring instances while we
            // figure out patterns/designs for module field editing
            ,
            supportsInlinePlaceholdersAndLabels: true,
            registerInlineFieldRef: this.registerInlineFieldRef
          })
        })]
      });
    } else if (hasInlineFieldEditing && !isPostBodyModule) {
      let body = widget.body;
      if (isSmartContentPreview) {
        if (selectedItemId !== widget.name) {
          return null;
        }
        const smartObjects = widget.smart_objects;
        if (selectedSmartRuleId && smartObjects) {
          const smartRule = smartObjects.find(obj => obj.criterion_id === selectedSmartRuleId);
          if (smartRule && smartRule.body) {
            body = smartRule.body;
          }
        }
      }
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [this.renderCrmInlineEditing(), /*#__PURE__*/_jsx(ModuleInlineEditingContainer, {
          moduleName: widget.name,
          onChange: this.handleInlineModuleChange,
          fields: moduleSchema.fields,
          fieldValues: body,
          inlineType: "module",
          inlineDataSource: widget.name
          // Used to simulate the `WidgetEditor's focus events since the
          // placeholder in tiny will swallow the click event
          ,
          handleFocusInlineRichTextWithPlaceholder: this.handleFocusInlineRichTextWithPlaceholder,
          updateMetaData: this.updateModuleMetaData,
          supportsInlinePlaceholdersAndLabels: false
          // @TODO: Remove the `isDataAuthoringModeActive` check in the componentDidUpdate when safe
          // registerInlineFieldRef={this.registerInlineFieldRef}
        })]
      });
    }
    // Never actually render any DOM, that is still the job of the WidgetEditor
    return this.renderCrmInlineEditing();
  }
}
WidgetEditorWrapper.propTypes = {
  widget: PropTypes.object.isRequired,
  gates: PropTypes.array.isRequired,
  bus: PropTypes.object.isRequired,
  scopes: PropTypes.array.isRequired,
  portalId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  moduleSchema: PropTypes.object,
  contentModelId: PropTypes.number.isRequired,
  isInDefaultBreakpointMode: PropTypes.bool.isRequired,
  shouldForceTinymceReadonlyIssue: PropTypes.bool.isRequired,
  isDataAuthoringModeActive: PropTypes.bool.isRequired,
  highlightedWidgetId: PropTypes.string,
  prevSelectedItemId: PropTypes.string,
  selectedItemId: PropTypes.string,
  isAnythingSelected: PropTypes.bool.isRequired,
  currentInpageMode: PropTypes.string.isRequired,
  sidebarIsExpanded: PropTypes.bool.isRequired,
  tinyMceGlobals: PropTypes.object.isRequired,
  pickerComponentsWithState: PropTypes.object.isRequired,
  // Specific state that some widget editors need (eventually to be retrieved via redux instead
  // of passing to _all_ widget editors)
  renderLanguage: PropTypes.string.isRequired,
  hasUndoRedoAccess: PropTypes.bool.isRequired,
  hasGlobalContentEditorAccess: PropTypes.bool.isRequired,
  isAdvancedPageTemplateWithAccess: PropTypes.bool.isRequired,
  isStarterPageTemplate: PropTypes.bool.isRequired,
  hasPersonalizationAccess: PropTypes.bool.isRequired,
  allModuleSchemasByCid: PropTypes.object.isRequired,
  allModuleSchemasByModuleId: PropTypes.object.isRequired,
  postBodyModulesByName: PropTypes.object.isRequired,
  builtInTypesByModuleId: PropTypes.object.isRequired,
  hasPreventTinymceTransformsOnUndo: PropTypes.bool.isRequired,
  hasNewCtasInRichText: PropTypes.bool.isRequired,
  customFontsList: PropTypes.array,
  hasTinyMCEParsedFonts: PropTypes.bool.isRequired,
  hasTinyMCEParsedFontsEnabled: PropTypes.bool.isRequired,
  selectedSmartRuleId: PropTypes.number,
  moduleMatchingSmartObjectIndex: PropTypes.number,
  isSmartContentPreview: PropTypes.bool,
  isBlogPost: PropTypes.bool.isRequired,
  isLandingPage: PropTypes.bool.isRequired,
  isSitePage: PropTypes.bool.isRequired,
  isLandingOrSitePage: PropTypes.bool.isRequired,
  applyChangesModalOpen: PropTypes.bool.isRequired,
  isDistractionFreeOpen: PropTypes.bool,
  hasAIGeneratedContentFeature: PropTypes.bool.isRequired,
  canUseCopilotCollaboration: PropTypes.bool.isRequired,
  hasImageGenerationAccess: PropTypes.bool.isRequired,
  isContentAssistanceEnabled: PropTypes.bool.isRequired,
  isUngatedForCaseStudyWidgetEditor: PropTypes.bool.isRequired,
  blogBrandVoice: PropTypes.object.isRequired,
  pageBrandVoice: PropTypes.object.isRequired,
  hasAccessToBrandVoice: PropTypes.bool.isRequired,
  hasAccessToAudioNarration: PropTypes.bool.isRequired,
  currentHubDbFields: PropTypes.array,
  crmObjectObjectAsCmv2Schema: PropTypes.object,
  crmObjectFieldValues: PropTypes.object,
  updateInstanceValue: PropTypes.func.isRequired,
  rowAsModuleBody: PropTypes.object,
  modulesInRichText: PropTypes.object,
  hasInlineFieldEditing: PropTypes.bool.isRequired,
  isUngatedToRepositionPostBodyModules: PropTypes.bool.isRequired,
  // Redux actions
  addModulesToPostBody: PropTypes.func.isRequired,
  closeRichTextEditorFirefox: PropTypes.func.isRequired,
  openRichTextEditorFirefox: PropTypes.func.isRequired,
  redoModuleReducerChange: PropTypes.func.isRequired,
  clearSelectedItem: PropTypes.func.isRequired,
  updateSelectedItem: PropTypes.func.isRequired,
  openConfirmEditGlobal: PropTypes.func.isRequired,
  undoModuleReducerChange: PropTypes.func.isRequired,
  updateInpageMode: PropTypes.func.isRequired,
  trackedFailedInpageAssets: PropTypes.func.isRequired,
  updatePostBodyFromInline: PropTypes.func.isRequired,
  updateTitleFromInline: PropTypes.func.isRequired,
  isPostBodyModule: PropTypes.bool.isRequired,
  updateInstanceMetaData: PropTypes.func.isRequired,
  openAudioNarrationPanel: PropTypes.func.isRequired,
  // Various functions the widget editors used to do by calling on a EditController reference
  tellParentToHideModuleMenu: PropTypes.func.isRequired,
  shouldShowFakeWidgetEditors: PropTypes.func.isRequired,
  updateNodePositions: PropTypes.func.isRequired,
  layoutSectionHoverPositionsClearedAndFrozen: PropTypes.func.isRequired,
  layoutSectionHoverPositionsThawed: PropTypes.func.isRequired
};
WidgetEditorWrapper.defaultProps = {
  tinyMceGlobals: {},
  pickerComponentsWithState: {}
};
export default connect(mapStateToProps, mapDispatchToProps)(WidgetEditorWrapper);